module.exports = __webpack_public_path__ + "assets/img/Claremont-School.ad59b3d1.png";